module.exports = __webpack_public_path__ + "img/pd-img16.0f171d1a.png";